import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  ClearSearchResponseType,
  GetInsightResponseType,
  GetPatentsResponseType,
  GetRecommendedCompaniesResponseType,
  GetSearchResponseType,
} from "@src/resources/ipSearch/ipSearch.service";

const c = initContract();

const index = c.router({
  clearSearch: {
    method: "GET",
    path: "/ip-search/clear-search",

    responses: {
      200: c.type<ClearSearchResponseType>(),
    },
  },
  getInsight: {
    body: z.object({
      companyId: z.string(),
      messages: z.array(z.string()).optional().nullable(),
      model: z.union([z.literal("openai"), z.literal("anthropic")]).optional(),
    }),
    method: "POST",
    path: "/ip-search/company-insight/:searchId",
    pathParams: z.object({
      searchId: z.string(),
    }),
    responses: {
      200: c.type<GetInsightResponseType>(),
    },
  },
  getRecommendedCompanies: {
    body: z.object({
      preferredIndustries: z.array(z.string()).optional(),
      queryString: z.string(),
    }),
    method: "POST",
    path: "/ip-search/recommended-companies/",
    responses: {
      200: c.type<GetRecommendedCompaniesResponseType>(),
    },
  },
  getSearch: {
    method: "GET",
    path: "/ip-search/load-search/:searchId/",
    pathParams: z.object({
      searchId: z.string(),
    }),
    responses: {
      200: c.type<GetSearchResponseType>(),
    },
  },
});

export default index;
